import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'garage-accredited',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `garage-accredited`,
    method: 'get',
    params: queriesParams
  })
}

export function addGarage (garage) {
  return request({
    method: 'post',
    url: 'garage-accredited',
    data: garage
  })
}

/**
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export function show (id) {
  return request({
    url: `garage-accredited/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `garage-accredited/${id}`,
    method: 'patch',
    data
  })
}
